<? if( _.some( _.invoke( visit_list, 'isSaving' ) ) ) { ?>

	<div class="p-3 bg-warning color-white">
		<p class="small uc text-center mb-0"><i class="fas fa-fw fa-spinner fa-spin"></i> Envoi des visites en cours</p>
	</div>

	<div class="py-2 px-3 bb">
		<p class="mb-0 text-center text-secondary small">Retrouvez ci-dessous vos visites de mares en attente d'envoi sur le serveur</p>
	</div>

<? } else if( type == 'draft' || _.some( _.invoke( visit_list, 'isSavable' ) ) ) { ?>

	<div class="p-3 bg-green color-white">
		<p class="small uc text-center mb-0">Visites en attente d'envoi</p>
	</div>

	<? if( _.size( visit_list ) ) { ?>

		<div class="py-2 px-3 bb">
			<p class="mb-0 text-center text-secondary small">Retrouvez ci-dessous vos visites de mares en attente d'envoi sur le serveur</p>
		</div>

		<? if( app.is('online') ) { ?>
			<div id="draft_sync">
				<div class="p-3 bb">
					<button type="submit" data-toggle="modal" data-target="#visit-draft-send-modal" class="btn btn-green btn-block"><i class="far fa-fw fa-cloud-upload"></i> Tout publier</button>
				</div>
			</div>
		<? } ?>

		<div id="visit-draft-send-modal" class="modal">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Attention !</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body">
						<p>Vous êtes sur le point de publier l'ensembles de vos visites en attente d'envoi.<br><br>Veuillez confirmer cette action.</p>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
						<button id="visit_draft_send_modal_confirm" type="button" class="btn btn-green">Confirmer</button>
					</div>
				</div>
			</div>
		</div>
	<? } ?>

<? } else { ?>

	<div class="p-3 bg-green color-white">
		<p class="small uc text-center mb-0">Visites envoyées</p>
	</div>

	<? if( _.size( visit_list ) ) { ?>
		<div class="py-2 px-3 bb">
			<p class="mb-0 text-center text-secondary small">Retrouvez ci-dessous vos visites de mares envoyées sur le serveur</p>
		</div>
	<? } ?>

<? } ?>

<div class="visit-list">
	<? _.each( visit_list, function( visit ) { ?>
		<a href="#<?=visit.toUrl('visit/view')?>" class="list-group-item list-group-item-action">
			<div class="d-flex justify-content-between align-items-center">
				<div>
					<p class="mb-1">
						<span class="badge badge-dark badge-md fw-400">Mare #<?=visit.get('pond_id')?></span>
						<span class="badge badge-<?=visit.getPond().getStatus().color?> badge-md fw-400"><?=visit.getPond().getStatus().name?></span>
					</p>
					<p class="mb-0">
						<span class="small fw-600"><?=visit.get('city_name')?></span>
						<br/><span class="small text-secondary">Visite du <?=visit.getDate('date')?></span>
					</p>
				</div>
				<div><?-visit.getIcon()?></div>
			</div>
		</a>
	<? }) ?>

	<? if( !_.size( visit_list ) ) { ?>
		<em class="list-group-item disabled text-center">
			Aucune visite trouvée
		</em>
	<? } ?>
</div>
